import { 
    FaFacebook, 
    FaInstagram, 
    FaLinkedin,
    FaGithub
} from 'react-icons/fa'
import { 
    FooterContainer, 
    FooterWrap, 
    SocialIconLink, 
    SocialIcons, 
    SocialLogo, 
    SocialMedia, 
    SocialMediaWrap 
} from './FooterElems'
import { HeroSpan } from '../Hero/HeroElems'
import { animateScroll as scroll } from 'react-scroll';

export default function index() {
  const toggleHome = () => {
    scroll.scrollToTop();
  }  
  return (
    <FooterContainer>
      <FooterWrap>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to='/' onClick={toggleHome}><span>&#123;</span>tyler<HeroSpan>Gan</HeroSpan><span>&#125;</span></SocialLogo>
            <SocialIcons>
              <SocialIconLink href='https://www.facebook.com/relytz.43' target='_blank' arial-label='Facebook'>
                <FaFacebook />
              </SocialIconLink>
              <SocialIconLink href='//www.instagram.com/relytz_/' target='_blank' arial-label='Instagram'>
                <FaInstagram/>
              </SocialIconLink>
              <SocialIconLink href='//www.linkedin.com/in/tylergan/' target='_blank' arial-label='Linkedin'>
                <FaLinkedin />
              </SocialIconLink>
              <SocialIconLink href='https://github.com/tylergan' target='_blank' arial-label='Linkedin'>
                <FaGithub />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  )
}
